<template>
	<ratio-div v-bind="$attrs" v-on="$listeners">
		<nio-image class="bg-image" :src="bgSrc" />
		<div class="mask"></div>
		<nio-image class="fr-image" :src="frSrc" />
	</ratio-div>
</template>

<script>
import RatioDiv from '@/components/RatioDiv'
import util from '@/util/util'
import { cdn } from '@/util/imgCdn'

export default {
	name: 'RatioImage',
	components: { RatioDiv },
	props: {
		src: {
			type: String,
			required: true
		},
		// imageView参数
		size: {
			type: Number,
			required: true
		}
	},
	computed: {
		bgSrc() {
			return (
				this.src +
				(`${this.src}`.indexOf('?') > 0 ? '&' : '?') +
				`imageMogr2/thumbnail/${this.size}x${this.size}/blur/${Math.ceil(
					(this.size * 47) / 335
				)}x200`
			)
		},
		frSrc() {
			return cdn(this.src, `/thumbnail/!${this.size}x${this.size}r`, true);
		}
	}
}
</script>

<style lang="scss" scoped>
.bg-image {
	position: absolute;
	width: 100%;
	height: 100%;
	::v-deep .nio-image {
		object-fit: cover;
	}
}

.mask {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.1);
}

.fr-image {
	position: absolute;
	width: 100%;
	height: 100%;
	::v-deep .nio-image {
		object-fit: contain;
	}
}
</style>
